const showDebugOutput =
  typeof window !== "undefined" &&
  new URL(window.location.toString()).searchParams.has("debug");

if (!showDebugOutput && import.meta.env.NODE_ENV !== "test") {
  console.log(
    "Map debugging disabled. Add search param '?debug=' to activate."
  );
}

export function debug(mode: "log" | "dir" | "warn") {
  return (...args: unknown[]) => {
    if (showDebugOutput) {
      console[mode](...args);
    }
  };
}
